module.exports = __webpack_public_path__ + "img/i_btn_list_b.f0b99f91.svg";